import { connect } from 'react-redux';
import { orgActions } from '../../../../store/orgSettings';
import { changeCurrentOnboardingStep, update } from '../../../../store/auth';

function mapStateToProps(state) {
  return {
    authUser: state.auth || {},
    settings: state.orgSettings,
    currentOnboardingStep: state.auth.currentOnboardingStep,
    subscription: state.subscription,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    get: () => dispatch(orgActions.getOrganizationInfoAction({})),
    changeCurrentOnboardingStep: (params) => dispatch(changeCurrentOnboardingStep(params)),
    updateOnViewTour: (params) => dispatch(update(params)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps);
